// A widget's status, worked out by the console API (never set by hand):
//   Draft  setup unfinished, so the widget won't start anywhere
//   Ready  all set, not yet seen on the installer's own website
//   Live   loaded on one of its allowed websites in the last 7 days
import type { Widget } from "../api";

const LABELS: Record<Widget["status"], string> = { draft: "Draft", ready: "Ready", live: "Live" };

/** The chip, with a tooltip saying why it has this status. */
export function StatusChip({ widget }: { widget: Widget }) {
  return (
    <span className={`status-chip status-${widget.status}`} title={statusReason(widget)}>
      {LABELS[widget.status]}
    </span>
  );
}

/** One sentence explaining the status (tooltip and screen readers). */
export function statusReason(w: Widget): string {
  if (w.status === "draft") return `Not running yet. To do: ${w.statusMissing.map((m) => m.text.toLowerCase()).join(", ")}.`;
  if (w.status === "live" && w.lastSeenOnSite) {
    const host = w.lastSeenOrigin ? new URL(w.lastSeenOrigin).host : "your website";
    return `Last seen on ${host}, ${new Date(w.lastSeenOnSite).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}.`;
  }
  return "Ready to go: it'll show as Live once it loads on your website.";
}
